import ProfileDetailUserDataSubAccountsView from './profileDetailUserDataSubAccountsView';
import { useRequestGetUserSubAccounts } from '@/hooks/httpRequest';
import { IBroadcastCommandEventOption } from '@/interfaces';
import { broadcastService } from '@/services';
import { useDocumentTitle } from '../hooks';
import PanelInfo from '../../PanelInfo';
import { Podcast } from 'lucide-react';
import Loader from '../../Loader';
import { useEffect } from 'react';

import { useProfileUserStore } from '../store/profileUserStore';

const ProfileDetailUserDataSubAccounts = ({ userId }: { userId: string }) => {

	const { userData } = useProfileUserStore();

	const { subAccounts, isLoadingSubAccounts, subAccountsUpdatedAt } = useRequestGetUserSubAccounts(
		{
			userId,
			config: {
				staleTime: 1000 * 60 * 60
			}
		},
		!!userId
	);
	console.log(subAccounts);

	const subAccountsFiltered = [...subAccounts].filter(l => l._id !== userId);

	/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */
	useDocumentTitle({ userData: userData as any, subAccounts: subAccountsFiltered });

	useEffect(
		() => {
			broadcastService
				.publish({
					type: 'events',
					payload: ({
						type: 'userSubAccountsLoaded',
						data: subAccountsFiltered
					}) as IBroadcastCommandEventOption
				});
		},
		[subAccountsUpdatedAt]
	);

	if (isLoadingSubAccounts) {
		return (
			<div className='my-10'>
				<Loader className='my-10' />
			</div>
		);
	}

	if (subAccountsFiltered.length === 0) {
		return (
			<div>
				<PanelInfo
					title={'Aucun sous compte.'}
					description={'Cet utilisateur ne possède aucun sous compte.'}
					className='py-10 md:py-26 border-none'
					icon={Podcast} />
			</div>
		);
	}

	return (
		<div className='flex flex-col space-y-3 animate-in fade-in slide-in-from-bottom-2 duration-500'>
			<ProfileDetailUserDataSubAccountsView accounts={subAccountsFiltered} forceCompact />
		</div>
	);
};

export default ProfileDetailUserDataSubAccounts;
